export default __webpack_public_path__ + "static/Actions-Schedule-3babe9ad409c939b292b31295df497ed.jpg";